export interface LeadLostTextProps {
  customerName: string;
  personalMessage?: string;
  senderName?: string;
}

const firstName = (fullName: string): string => {
  const parts = (fullName || '').trim().split(/\s+/).filter(Boolean);
  return parts[0] || 'there';
};

export const leadLostText = async (
  params: LeadLostTextProps,
): Promise<{ body: string }> => {
  const { customerName, personalMessage, senderName } = params;
  const greetingName = firstName(customerName);
  const personal = (personalMessage || '').trim();

  const sections = [
    `Hi ${greetingName} — no pressure at all, just wanted to keep the door open.`,
  ];

  if (personal) {
    sections.push(personal);
  } else {
    sections.push(
      "If anything changes or you'd like to revisit, we're here. Either way, hope it's going well.",
    );
  }

  sections.push(
    senderName
      ? `– ${senderName}, Optic Truck Works`
      : '– The Optic Truck Works Team',
  );

  return { body: sections.join('\n\n') };
};
